import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ListingInformationDetail {
    constructor(doc)
    {
		this.label = null;
		this.daysOnMarketCount = null;
		this.finalListPriceAmount = null;
		this.initialListPriceAmount = null;
		this.listingEndDate = null;
		this.listingIdentifier = null;
		this.listingStartDate = null;
		this.listingStatusType = null;
		this.listingType = null;
		this.listingTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.daysOnMarketCount = x.getIntegerElement(doc, "./ns:DaysOnMarketCount");
		this.finalListPriceAmount  = x.getMISMOAmountElement(doc, "./ns:FinalListPriceAmount");
		this.initialListPriceAmount  = x.getMISMOAmountElement(doc, "./ns:InitialListPriceAmount");
		this.listingEndDate = x.getMISMODateElement(doc, "./ns:ListingEndDate");
		this.listingIdentifier = x.getStringElement(doc, "./ns:ListingIdentifier");
		this.listingStartDate = x.getMISMODateElement(doc, "./ns:ListingStartDate");
		this.listingStatusType = x.getStringElement(doc, "./ns:ListingStatusType");
		this.listingType = x.getStringElement(doc, "./ns:ListingType");
		this.listingTypeOtherDescription = x.getStringElement(doc, "./ns:ListingTypeOtherDescription");
   }
}

export class ListingInformation {
    constructor(doc)
    {
		this.label = null
		this.listingInformationDetail = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:LISTING_INFORMATION_DETAIL");
		if (node !== null)
				this.listingInformationDetail = new ListingInformationDetail(node);
   }

	GetListingType() {
		return h.descriptionOrOther(this.listingInformationDetail.listingType, this.listingInformationDetail.listingTypeOtherDescription);
	}

	GetListingStatusType() {
		return h.descriptionOrOther(this.listingInformationDetail.listingStatusType, this.listingInformationDetail.listingStatusTypeOtherDescription);
	}

}
